<div class="projeto"  [ngClass]="{'print-page':print}">
  <div class="d-flex">
    <h3>Projetos</h3>
  </div>
  <ng-container *ngFor="let agency of agencies" >
    <mat-accordion class="example-headers-align mb-0" [togglePosition]="'before'">
      <mat-expansion-panel class="session mb-0" [expanded]="true">
        <mat-expansion-panel-header  class="session-title  py-2 ">
          <mat-panel-title class="d-flex justify-content-between row">
            <div class="col-11 col-md-4 col-lg-7 d-flex">
              <b class="me-1">{{agency?.str_sigla}}</b>
              <span class="mat-title">{{agency?.str_nome}}</span>
              <button *ngIf="!print" class="btn btn-icon" (click)="$event.stopPropagation(); openAchievementAndGoal(agency)" alt="Abrir Projeção e Metas" title="Abrir Projeção e Metas">
                <img  [src]="iconData" type="image/svg+xml">
              </button>
              <!--<object  [data]="statusProjection" type="image/svg+xml"></object>-->
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <article>
          <section class="card-item" *ngFor="let project of agency?.project_full">
            <div class="card-body">
              <div>
                <span>{{project.title}}</span>
                <div class="d-flex flex-wrap mt-1">
                  <div class="tag strategic mb-1" *ngIf="project.level_priority == 1">ESTRATÉGICO</div>
                  <div class="tag irfe mb-1" *ngIf="project.irfe_enabled_id == 1">IRFE</div>
                  <div class="tag ircp mb-1" *ngIf="project.ircp_enabled_id == 1">IRCP</div>
                  <div class="tag plano_rio_grande mb-1" *ngIf="project?.pf_program?.pg_id == 144 || project?.pg_id == 144">PLANO RIO GRANDE</div>
                  <div class="tag plano_de_desenvolvimento mb-1" *ngIf="project?.pg_id == 172">PLANO DESENVOLVIMENTO</div>
                </div>
              </div>
              <div class="card-buttons" *ngIf="!print">
                <a [href]="generateLinkProject(project)" target="_blank">
                  <span class="icon" title="Abrir projeto" >open_in_new</span>
                </a>
                <a  (click)="navigate(project.slide)">
                  <span class="icon" title="Apresentar">pan_zoom</span>
                </a>
              </div>
            </div>
          </section>
        </article>
      </mat-expansion-panel>
    </mat-accordion>
  </ng-container>
</div>
<ng-template #modal>
  <app-apresentacao-slide-modal 
    [currentIndicator]="currentModalData" 
    [meetingId]="id" 
    titleId="achievementAndGoal" 
    [filters]="filters" 
    (closeModal)="closeModal()">
  </app-apresentacao-slide-modal>
</ng-template>
<app-loading [loader]="isLoading"></app-loading>